module.exports = __webpack_public_path__ + "img/home.7dbf9957.png";